import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import ReactECharts from 'echarts-for-react';
import BrandLogo from '../components/layout/BrandLogo';

const { FiUser, FiBell, FiLock, FiSmartphone, FiChevronRight } = FiIcons;

export default function Settings() {
  const chartOptions = {
    tooltip: { trigger: 'item' },
    legend: { show: false },
    series: [{
      name: 'Weekly Activities',
      type: 'pie',
      radius: ['60%', '90%'],
      avoidLabelOverlap: false,
      itemStyle: { borderRadius: 12, borderColor: '#fff', borderWidth: 4 },
      label: { show: false },
      data: [
        { value: 10, name: 'School', itemStyle: { color: '#1a365d' } },
        { value: 5, name: 'Sports', itemStyle: { color: '#3b82f6' } },
        { value: 3, name: 'Chores', itemStyle: { color: '#fde047' } },
        { value: 8, name: 'Family Time', itemStyle: { color: '#10b981' } }
      ]
    }]
  };

  return (
    <div className="max-w-4xl mx-auto space-y-10 pb-24">
      <header>
        <h2 className="text-4xl font-black text-[#1a365d] tracking-tighter">Settings & Insights</h2>
        <p className="text-slate-500 font-medium mt-2">Manage your command center and family data.</p>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div className="bg-white rounded-[2.5rem] p-8 shadow-xl border border-slate-100">
          <h3 className="text-xl font-black mb-8 text-slate-800">Preferences</h3>
          <div className="space-y-3">
            {[
              { icon: FiUser, title: 'Family Profile', desc: '4 members active' },
              { icon: FiBell, title: 'Notifications', desc: 'Push & SMS enabled' },
              { icon: FiSmartphone, title: 'Connected Devices', desc: '3 mobile devices' },
              { icon: FiLock, title: 'Privacy Vault', desc: 'End-to-end active' },
            ].map((item, idx) => (
              <div key={idx} className="flex items-center gap-5 p-4 hover:bg-slate-50 rounded-2xl cursor-pointer transition-all border-2 border-transparent hover:border-slate-100 group">
                <div className="w-12 h-12 rounded-2xl bg-slate-100 flex items-center justify-center text-[#1a365d] transition-colors group-hover:bg-yellow-300">
                  <SafeIcon icon={item.icon} className="text-xl" />
                </div>
                <div className="flex-1">
                  <h4 className="font-black text-slate-800 text-sm">{item.title}</h4>
                  <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest">{item.desc}</p>
                </div>
                <SafeIcon icon={FiChevronRight} className="text-slate-300" />
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white rounded-[2.5rem] p-8 shadow-xl border border-slate-100 flex flex-col">
          <div className="mb-8">
            <h3 className="text-xl font-black text-slate-800">Activity Balance</h3>
            <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-1">This Week's Breakdown</p>
          </div>
          <div className="flex-1 min-h-[250px] relative">
            <ReactECharts option={chartOptions} style={{ height: '100%', width: '100%' }} />
            <div className="absolute inset-0 flex items-center justify-center flex-col pointer-events-none">
              <span className="text-3xl font-black text-[#1a365d]">26</span>
              <span className="text-[10px] font-black text-slate-400 uppercase">Events</span>
            </div>
          </div>
        </div>
      </div>

      <footer className="pt-20 flex flex-col items-center gap-6">
        <BrandLogo size="md" color="dark" />
        <p className="text-slate-400 text-[10px] font-black tracking-[0.3em] uppercase">
          Made by LingLink AI and DigLab AI
        </p>
      </footer>
    </div>
  );
}